/** Posts height and width to the window on resize */
export const subscribeToContentSize = () => window.addEventListener('load', resizeHandler);

export const resizeHandler = () => {
	const contentArea = document.getElementById('full-height-container');
	if (!contentArea) return;

	new ResizeObserver(postOnContentSizeChange).observe(contentArea);
};

export const postOnContentSizeChange = (entries: Array<ResizeObserverEntry>) =>
	entries.forEach(({ target: { scrollHeight, scrollWidth } }) => {
		window.parent?.postMessage(
			{
				type: 'contentSize',
				height: scrollHeight,
				width: scrollWidth,
			},
			'*',
		);
	});
